import dynamic from 'next/dynamic';

export default {
  // Navigation
  BreadCrumbs: dynamic(() => import('@eneco/sitecore-components-content/Breadcrumbs/Breadcrumbs')),
  FooterMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/FooterMenu')),
  Footer: dynamic(() => import('@eneco/sitecore-components-content/Footer/Footer')),
  LanguageSelector: dynamic(() => import('@eneco/sitecore-components-content/LanguageSelector/LanguageSelector')),
  Logo: dynamic(() => import('@eneco/sitecore-components-eneco/ImageLink/ImageLink')),
  MainNavigation: dynamic(() => import('@apps/header-be-eneco/BeHeader')),
  HeaderLink: dynamic(() => import('@apps/header-be-eneco/HeaderLink')),
  MegaMenu: dynamic(() => import('@eneco/sitecore-components-content/MegaMenu/MegaMenu')),
  MegaMenuV2: dynamic(() => import('@eneco/sitecore-components-content/MegaMenuV2/MegaMenuV2')),
  MegaMenuDivision: dynamic(() => import('@eneco/sitecore-components-content/MegaMenuDivision/MegaMenuDivision')),
  MessageBar: dynamic(() => import('@eneco/sitecore-components-content/MessageBar/MessageBar')),
  NotificationsBar: dynamic(() => import('@eneco/sitecore-components-content/NotificationsBar/NotificationsBar')),
  SubFooterMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/SubFooterMenu')),
  SocialMediaMenu: dynamic(() => import('@eneco/sitecore-components-content/Footer/SocialMediaMenu')),

  // Content components
  ContentCategories: dynamic(() => import('@eneco/sitecore-components-content/ContentCategories/ContentCategories')),
  ChatLinks: dynamic(() => import('@eneco/sitecore-components-content/ChatLinks/ChatLinks')),
  Accordion: dynamic(() => import('@eneco/sitecore-components-content/Accordion/Accordion')),
  Hero: dynamic(() => import('@eneco/sitecore-components-content/Hero/Hero')),
  HeroRebranded: dynamic(() => import('@eneco/sitecore-components-content/HeroRebranded/HeroRebranded')),
  NotificationBox: dynamic(() => import('@eneco/sitecore-components-content/NotificationBox/NotificationBox')),
  RichText: dynamic(() => import('@eneco/sitecore-components-content/RichText/RichText')),
  TopTasks: dynamic(() => import('@eneco/sitecore-components-content/TopTasks/TopTasks')),
  ContactCustomerService: dynamic(
    () => import('@eneco/sitecore-components-content/ContactCustomerService/ContactCustomerService'),
  ),
  Image: dynamic(() => import('@eneco/sitecore-components-content/Image/Image')),
  List: dynamic(() => import('@eneco/sitecore-components-content/List/List')),
  HeroCard: dynamic(() => import('@eneco/sitecore-components-content/HeroCard/HeroCard')),
  HeroCardRebranded: dynamic(() => import('@eneco/sitecore-components-content/HeroCardRebranded/HeroCardRebranded')),
  LinkCard: dynamic(() => import('@eneco/sitecore-components-content/LinkCard/LinkCard')),
  StoreButtons: dynamic(() => import('@eneco/sitecore-components-content/StoreButtons/StoreButtons')),
  SimpleTable: dynamic(() => import('@eneco/sitecore-components-content/SimpleTable/SimpleTable')),
  TextStreamer: dynamic(() => import('@eneco/sitecore-components-content/TextStreamer/TextStreamer')),
  UsabillaFeedback: dynamic(() => import('@eneco/sitecore-components-system/UsabillaFeedback/UsabillaFeedback')),
  WeDoenHetNuTestimonialsCard: dynamic(
    () => import('@eneco/sitecore-components-content/WeDoenHetNuTestimonialsCard/WeDoenHetNuTestimonialsCard'),
  ),
  //AddressFinder: dynamic(() => import('@eneco/sitecore-components-content/AddressFinder/AddressFinder')),
  StepExplainer: dynamic(
    () => import('@eneco/sitecore-components-content/StepExplainerVertical/StepExplainerVertical'),
  ),
  CreditWarningBar: dynamic(() => import('@eneco/sitecore-components-content/CreditWarningBar/CreditWarningBar')),
  ShareOnSocials: dynamic(() => import('@eneco/sitecore-components-content/ShareOnSocials/ShareOnSocials')),
  ButtonLink: dynamic(() => import('@eneco/sitecore-components-content/ButtonLink/ButtonLink')),
  BecomeACustomer: dynamic(() => import('@eneco/sitecore-components-content/ButtonLink/ButtonLink')),
  ButtonLineUp: dynamic(() => import('@eneco/sitecore-components-content/ButtonLineUp/ButtonLineUp')),
  Price: dynamic(() => import('@eneco/sitecore-components-content/Price/Price')),
  IconList: dynamic(() => import('@eneco/sitecore-components-content/IconList/IconList')),
  ContentHubFilter: dynamic(() => import('@eneco/sitecore-components-content/ContentHubFilter/ContentHubFilter')),
  FlourishChart: dynamic(() => import('@eneco/sitecore-components-content/FlourishChart/FlourishChart')),
  PromoBox: dynamic(() => import('@eneco/sitecore-components-content/PromoBox/PromoBox')),
  ProjectOverview: dynamic(() => import('@eneco/sitecore-components-content/ProjectOverview/ProjectOverview')),
  SmartHomeBattery: dynamic(() => import('@eneco/sitecore-components-content/SmartHomeBattery/SmartHomeBattery')),

  // Apps
  //CustomerReview: dynamic(() => import('@apps/customerreview-shared-multilabel/CustomerReview')),
  /*DynamicPricingTariffs: dynamic(
    () => import('@apps/dynamicpricingtariffs-shared-multilabel/DynamicPricingTariffs/DynamicPricingTariffs'),
  ),*/

  // Other
  CookieWall: dynamic(() => import('@apps/cookiewall-nl-multilabel/CookieWall')),
  ErrorPage: dynamic(() => import('@eneco/sitecore-components-content/ErrorPage/ErrorPage')),
  GTM: dynamic(() => import('@apps/gtm-be-eneco/GTMTag')),
  Vwo: dynamic(() => import('@eneco/sitecore-components-system/Vwo/Vwo')),
  Hotjar: dynamic(() => import('@eneco/sitecore-components-system/Hotjar/Hotjar')),
  MetaData: dynamic(() => import('@eneco/sitecore-components-system/MetaData/MetaData')),
  MetaTags: dynamic(() => import('@eneco/sitecore-components-system/MetaTags/MetaTags')),
  StructuredDataSchema: dynamic(
    () => import('@eneco/sitecore-components-system/StructuredDataSchema/StructuredDataSchema'),
  ),
  Chat: dynamic(() => import('@apps/chat-shared-multilabel/Chat')),
  /*ContractConfirmation: dynamic(
    () => import('@eneco/sitecore-components-content/ContractConfirmation/ContractConfirmation'),
  ),*/

  // Wrapper components
  Article: dynamic(() => import('@eneco/sitecore-components-content/Article/Article')),
  Centered: dynamic(() => import('@eneco/sitecore-components-content/Centered/Centered')),
  Section: dynamic(() => import('@eneco/sitecore-components-content/Section/Section')),
  LineUp: dynamic(() => import('@eneco/sitecore-components-content/LineUp/LineUp')),
  NavigationView: dynamic(() => import('@eneco/sitecore-components-content/NavigationView/NavigationView')),
  SplitView: dynamic(() => import('@eneco/sitecore-components-content/SplitView/SplitView')),
  Carousel: dynamic(() => import('@eneco/sitecore-components-content/Carousel/Carousel')),

  // Wrappable components
  ArticleCard: dynamic(() => import('@eneco/sitecore-components-content/ArticleCard/ArticleCard')),
  ArticleContentCard: dynamic(() => import('@eneco/sitecore-components-content/ArticleContentCard/ArticleContentCard')),
  ContentCard: dynamic(() => import('@eneco/sitecore-components-content/ContentCard/ContentCard')),
  ContentCardRebranded: dynamic(
    () => import('@eneco/sitecore-components-content/ContentCardRebranded/ContentCardRebranded'),
  ),
  ProductCard: dynamic(() => import('@eneco/sitecore-components-content/ProductCard/ProductCard')),
  StickyNav: dynamic(() => import('@eneco/sitecore-components-content/StickyNav/StickyNav')),
  Table: dynamic(() => import('@eneco/sitecore-components-content/Table/Table')),
  TitleTextCTA: dynamic(() => import('@eneco/sitecore-components-content/TitleTextCTA/TitleTextCTA')),
  /*PersonalizedTitleTextCTA: dynamic(
    () => import('@eneco/sitecore-components-content/PersonalizedTitleTextCTA/PersonalizedTitleTextCTA'),
  ),*/
  Checklist: dynamic(() => import('@eneco/sitecore-components-content/Checklist/Checklist')),
  USPItem: dynamic(() => import('@eneco/sitecore-components-content/USPItem/USPItem')),
  Video: dynamic(() => import('@eneco/sitecore-components-content/Video/Video')),
  PersonalizationCookieController: dynamic(
    () => import('@eneco/sitecore-components-system/PersonalizationCookieController/PersonalizationCookieController'),
  ),
  /*
  // EnergyRating
  RegistrationAccountCreate: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationFlow/RegistrationFlow'),
  ),
  RegistrationAccountReset: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationFlow/RegistrationFlow'),
  ),
  RegistrationFooter: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationFooter/RegistrationFooter'),
  ),
  RegistrationHeader: dynamic(
    () => import('@apps/accessmanagement-nl-multilabel/components/RegistrationHeader/RegistrationHeader'),
  ),
  */

  // Campaign components
  WeDoenHetNuCard: dynamic(
    () => import('@eneco/sitecore-components-content/Road2Zero/WeDoenHetNuCard/WeDoenHetNuCard'),
  ),
  WeDoenHetNuTextImage: dynamic(
    () => import('@eneco/sitecore-components-content/Road2Zero/WeDoenHetNuTextImage/WeDoenHetNuTextImage'),
  ),
  TextImageRebranded: dynamic(() => import('@eneco/sitecore-components-content/TextImageRebranded/TextImageRebranded')),

  // Forms
  // ContactForm: dynamic(() => import('@eneco/sitecore-components-forms/ContactForm/ContactForm')),
  //  GenericForm: dynamic(() => import('@eneco/sitecore-components-forms/GenericForm/GenericForm')),
  EloquaForm: dynamic(() => import('@eneco/sitecore-components-forms/GenericForm/EloquaForm')),
  // HeatDamageForm: dynamic(() => import('@eneco/sitecore-components-forms/HeatDamageForm/HeatDamageForm')),
  /* RegisterToNewsletterForm: dynamic(
    () => import('@eneco/sitecore-components-forms/RegisterToNewsletterForm/RegisterToNewsletterForm'),
  ),
  EmailRequestWrapper: dynamic(
    () => import('@eneco/sitecore-components-forms/EmailRequestWrapper/EmailRequestWrapper'),
  ),*/

  GenericFormAddressField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormAddress/GenericFormAddressField'),
  ),
  GenericFormBeAddressField: dynamic(
    () =>
      import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormAddress/GenericFormBeAddressField'),
  ),
  GenericFormNameField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormNameField/GenericFormNameField'),
  ),
  GenericFormParagraph: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormParagraph/GenericFormParagraph'),
  ),
  GenericFormSalutationField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormSalutation/GenericFormSalutation'),
  ),
  GenericFormRadioGroup: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormRadioGroup/GenericFormRadioGroup'),
  ),
  GenericFormCheckboxField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormCheckboxField/GenericFormCheckboxField'
      ),
  ),
  GenericFormCheckboxGroup: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormCheckboxGroup/GenericFormCheckboxGroup'
      ),
  ),
  GenericFormDateField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormDateField/GenericFormDateField'),
  ),
  GenericFormEmailInputField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormEmailInputField/GenericFormEmailInputField'
      ),
  ),
  GenericFormNumberInputField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormNumberInputField/GenericFormNumberInputField'
      ),
  ),
  GenericFormPhoneNumberInputField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormPhoneNumberInputField/GenericFormPhoneNumberInputField'
      ),
  ),
  GenericFormInputField: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormInputField/GenericFormInputField'),
  ),
  GenericFormTextAreaInputField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormTextAreaInputField/GenericFormTextAreaInputField'
      ),
  ),
  GenericFormInputSelect: dynamic(
    () =>
      import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormInputSelect/GenericFormInputSelect'),
  ),
  GenericFormDivider: dynamic(
    () => import('@eneco/sitecore-components-forms/GenericForm/Components/GenericFormDivider/GenericFormDivider'),
  ),
  GenericFormInputHiddenField: dynamic(
    () =>
      import(
        '@eneco/sitecore-components-forms/GenericForm/Components/GenericFormInputHiddenField/GenericFormInputHiddenField'
      ),
  ),
  DynamicPricingGraph: dynamic(
    () => import('@eneco/sitecore-components-content/DynamicPricingGraph/DynamicPricingGraph'),
  ),
  SearchChatBot: dynamic(() => import('@apps/header-be-eneco/components/SearchChatBot')),

  // MyZone

  ProfileManagementLoginDetails: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/login-details/ProfileManagementLoginDetails'),
  ),
  ProfileManagementLoginDetailsUpdate: dynamic(
    () =>
      import('@apps/myzone-be-eneco/pages/my-eneco/profile/login-details/update/ProfileManagementLoginDetailsUpdate'),
  ),
  ProfileManagementLoginDetailsConfirmEmail: dynamic(
    () =>
      import(
        '@apps/myzone-be-eneco/pages/my-eneco/profile/login-details/confirm-email-change/ProfileManagementLoginDetailsConfirmEmail'
      ),
  ),
  ProfileManagementLoginDetailsLinkItsme: dynamic(
    () =>
      import(
        '@apps/myzone-be-eneco/pages/my-eneco/profile/login-details/link-itsme/ProfileManagementLoginDetailsLinkItsme'
      ),
  ),
  ForgotEmail: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/forgot-email/ForgotEmail')),
  ForgotEmailConfirmed: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/forgot-email-confirmed/ForgotEmailConfirmed'),
  ),
  ProfileMenuBe: dynamic(() => import('@apps/header-be-eneco/components/ProfileMenuBE')),
  Agreement: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/privacy-policy/Agreement')),
  AccountMergeEmailCallback: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/account-merge-email/AccountMergeEmailCallback'),
  ),
  AccountInviteForm: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/account/accept-invite/AccountInviteForm'),
  ),
  OwnerReassignment: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/account/owner-reassignment/OwnerReassignmentForm'),
  ),
  OwnerReassignmentConfirmation: dynamic(
    () =>
      import('@apps/myzone-be-eneco/pages/my-eneco/profile/account/owner-reassignment/OwnerReassignmentConfirmation'),
  ),
  EditChildAccountForm: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/account/edit/EditChildAccountForm'),
  ),
  AccountLinkDialog: dynamic(() => import('@apps/myzone-be-eneco/components/AccountLinkDialog/AccountLinkDialog')),
  AccountLinkDialogNavLink: dynamic(
    () => import('@apps/myzone-be-eneco/components/AccountLinkDialog/AccountLinkDialogNavLink'),
  ),
  DashboardOverview: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/dashboard/Dashboard')),
  AccountOverview: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/profile/account/AccountOverview')),
  EditCrmAccountDetails: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/account/change/EditCrmAccountDetails'),
  ),
  SideNav: dynamic(() => import('@eneco/sitecore-components-content/SideNav/SideNav')),
  LogoutLink: dynamic(() => import('@apps/header-be-eneco/components/LogoutNavLink')),
  ImpersonationLanding: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/impersonation/ImpersonationLanding'),
  ),
  ContactData: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/profile/contact-details/ContactData')),
  ContactPreferences: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/contact-preferences/ContactPreferences'),
  ),
  EditContactData: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/contact-details/edit/EditContactData'),
  ),
  EditGezinsbond: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/contact-details/gezinsbond/EditGezinsbond'),
  ),
  CompanyData: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/contact-details/company/EditCompanyData'),
  ),
  ProspectCta: dynamic(() => import('@apps/myzone-be-eneco/components/ProspectCta/ProspectCta')),
  MyEnecoProduct: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/products/ProductOverview')),
  MyEnecoProductDetails: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/products/detail/ProductDetail')),
  MyEnecoComfortBonus: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/products/ComfortBonus')),
  MyEnecoProductUpdateMeterRegime: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/products/meterregime/EditMeterRegime'),
  ),
  MyEnecoInvoice: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/invoices/InvoiceOverview')),
  MyEnecoExportPaymentsAndInvoices: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/invoices/export/ExportPaymentsOverview'),
  ),
  MyEnecoInvoiceBillingDetails: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/payments/BillingDetails'),
  ),
  MyEnecoUpdateInvoicePaymentMethod: dynamic(
    () =>
      import('@apps/myzone-be-eneco/pages/my-eneco/profile/payments/update-payment-method/UpdateInvoicePaymentMethod'),
  ),
  MyEnecoInvoiceEditDueDate: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/payments/edit-due-date/InvoiceEditDueDate'),
  ),
  MyEnecoEditInvoiceFrequency: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/payments/edit-invoice-frequency/InvoiceEditFrequency'),
  ),
  QuickLinks: dynamic(() => import('@eneco/sitecore-components-eneco/QuickLinks/MyEnecoQuickLinksWrapper')),
  MyEnecoUpcomingYearlyInvoice: dynamic(
    () =>
      import(
        '@apps/myzone-be-eneco/pages/my-eneco/invoices/components/sidebar/UpcomingYearlyInvoice/UpcomingYearlyInvoiceWrapper'
      ),
  ),
  MoveOnboarding: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/move/MoveOnboarding')),
  SelectMoveReason: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/move/select-reason/MoveSelectReason')),

  MoveEODUpload: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/move/eod/MoveEodUploadStep')),
  MoveNewAddressStep: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/move/new-address/MoveNewAddress')),
  MoveOverviewStep: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/move/confirmation-overview/MoveOverviewStep'),
  ),
  MoveInDateStep: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/move/move-in-date/MoveInDateStep')),
  MovingOutDateStep: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/move/move-out-date/MoveOutDateStep')),
  MoveFileAddressDetails: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/move/address-details/MoveFileAddressDetails'),
  ),
  MoveBillingAddressStep: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/move/billing-address/MoveBillingAddressStep'),
  ),
  MoveResidentChangeContactDetails: dynamic(
    () =>
      import(
        '@apps/myzone-be-eneco/pages/my-eneco/move/resident-change-contact-details/MoveResidentChangeContactDetails'
      ),
  ),
  MoveFileEditAddress: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/move/edit-date/MoveFileEditAddress')),
  MoveFileContactDetails: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/move/contact-details/MoveFileContactDetails'),
  ),
  MoveEditMeterDetails: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/move/meter-details/MoveEditMeterDetailsNavigationWrapper'),
  ),
  MoveOutStatusIndicator: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/move/components/MoveOutStatusIndicator'),
  ),
  FlowStepIndicator: dynamic(() => import('@apps/myzone-be-eneco/components/FlowStepIndicator')),
  ManageAdvanceAmount: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/advance/AdvancePaymentsOverview')),
  EditAdvanceAmount: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/advance/edit/EditAdvancePayments')),
  AnalogueMeterCustomersCTA: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/advance/components/EnergyMonitorCta'),
  ),
  RequestVacancy: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/advance/leegstand/RequestVacancy')),
  PaymentPlanOnboarding: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/payment-plan/PaymentPlanOnboarding'),
  ),
  PaymentPlanAmountStep: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/payment-plan/amount/PaymentPlanAmountStep'),
  ),
  PaymentPlanTypeStep: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/payment-plan/type/PaymentPlanTypeStep'),
  ),
  PaymentArrangementProposalPlanStep: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/payment-plan/proposal/PaymentPlanProposalStep'),
  ),
  MandateInformation: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/profile/payments/components/MandateInfoBucket'),
  ),
  ProductSwitch: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/product-switch/ProductSwitch')),
  ConsumptionGraphicalOverview: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/usage/ConsumptionGraphicalOverview'),
  ),
  EnterMeterReadings: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/usage/add-meter-readings/AddMeterReading'),
  ),
  ContactUs: dynamic(() => import('@apps/myzone-be-eneco/pages/contact-form/ContactForm')),
  CancelOrder: dynamic(() => import('@apps/myzone-be-eneco/pages/cancel-order/CancelOrder')),
  Rectification: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/rectification/Rectification')),
  PriceSimulation: dynamic(() => import('@apps/myzone-be-eneco/pages/price-simulation/PriceSimulation')),
  FlowStepIndicatorHeader: dynamic(
    () => import('@apps/myzone-be-eneco/components/navigation/flow/FlowStepIndicatorHeader'),
  ),
  Dashboard: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/dashboard/Dashboard')),
  OrderManagement: dynamic(() => import('@apps/myzone-be-eneco/pages/order-management/OrderManagement')),
  PaymentConfirmation: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/betaling/confirmation/PaymentConfirmation'),
  ),
  BbpCampaign: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/bbp/BbpCampaign')),
  SmartTargetingBanner: dynamic(
    () => import('@apps/myzone-be-eneco/components/SmartTargetingBanner/SmartTargetingBanner'),
  ),
  ContactFormDeflection: dynamic(
    () => import('@apps/myzone-be-eneco/pages/contact-form-deflection/ContactFormDeflection'),
  ),
  ConsumptionTariffOptions: dynamic(
    () => import('@apps/myzone-be-eneco/pages/my-eneco/products/detail/ConsumptionTariffOptions'),
  ),
  DirectDebitCTA: dynamic(() => import('@apps/myzone-be-eneco/pages/my-eneco/payment-plan/DirectDebitCta')),
};
